import router from './router'
import store from './store/index'
import api from './api'

const whiteList = ['/login']
let validatedToken = ''

router.beforeEach(async (to, from, next) => {
	document.title = to.meta.title || 'LinkMe管理后台'
	const token = store.getters.token
	if (!token) {
		validatedToken = ''
		if (whiteList.indexOf(to.path) !== -1) {
			next()
		} else {
			next({ path: '/login', query: { redirect: to.fullPath } })
		}
		return
	}

	if (to.path === '/login') {
		next('/users')
		return
	}
	if (validatedToken === token) {
		if (to.meta.requiresSuper && Number((store.getters.user || {}).type) !== 1) {
			next('/users')
			return
		}
		next()
		return
	}

	try {
		const profile = await api.user.getUserInfo()
		store.commit('user/setUserInfo', profile)
		validatedToken = token
		if (to.meta.requiresSuper && Number(profile.type) !== 1) next('/users')
		else next()
	} catch (error) {
		store.commit('user/logout')
		validatedToken = ''
		next({ path: '/login', query: { redirect: to.fullPath } })
	}
})
